// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6b101d31e012b90ee6b1","655":"3c4c35df12c3ed527957"}[chunkId] + ".js";
};